export type TimelineMode = 'activity' | 'journey';

interface TimelineModeToggleProps {
    mode: TimelineMode;
    onChange: (mode: TimelineMode) => void;
}

/**
 * Segmented Activity | Journey switch shared by the patient-files timeline
 * rail and the work-queue detail panel. Activity = the event feed; Journey =
 * the steps/phases the patient went through, with durations.
 */
export function TimelineModeToggle({ mode, onChange }: TimelineModeToggleProps) {
    // Plain toggle buttons (aria-pressed), not tablist semantics — there is no
    // arrow-key navigation or tabpanel wiring here, so tab roles would overclaim.
    return (
        <div
            className="flex items-center gap-0.5 bg-gray-100 rounded-md p-0.5"
            role="group"
            aria-label="Timeline view"
        >
            {(['activity', 'journey'] as const).map((m) => (
                <button
                    key={m}
                    type="button"
                    aria-pressed={mode === m}
                    onClick={() => onChange(m)}
                    className={`px-1.5 py-0.5 rounded text-[10px] font-semibold capitalize transition-colors ${
                        mode === m
                            ? 'bg-white shadow-sm text-gray-800'
                            : 'text-gray-400 hover:text-gray-600'
                    }`}
                >
                    {m}
                </button>
            ))}
        </div>
    );
}
